export const SEARCH_TYPE_NMI = "nmi";
export const SEARCH_TYPE_TRANSACTION_ID = "transaction-id";
export const SEARCH_TYPE_HISTORICAL_NMI = "historical-nmi";

export const SEARCH_DATA_TYPE_ACTIVE = "active";
export const SEARCH_DATA_TYPE_HISTORICAL = "historical";
